<template>
  <div v-if="$auth.check()">
    <v-row align="center">
      <v-col cols="12" sm="8">
        <h1>Infra v1.0</h1>
      </v-col>
      <v-col cols="12" sm="4" class="text-sm-right">
        <v-btn color="primary" @click="load()" :disabled="loading > 0">
          <v-icon left>mdi-refresh</v-icon>atualizar
        </v-btn>
      </v-col>
    </v-row>

    <v-progress-linear indeterminate color="primary" class="mb-2" v-if="loading > 0"></v-progress-linear>

    <v-row>
      <v-col cols="12" sm="6" md="3" v-if="$auth.check('INFRA_VIABILIDADE')">
        <v-card>
          <v-card-text>
            <div class="text-overline">Viabilidades aguardando</div>
            <div class="text-h4 primary--text">{{ contador(aguardando) }}</div>
            <div class="text-caption">{{ atrasadas.length }} parada(s) ha 3 dias ou mais</div>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" sm="6" md="3" v-if="$auth.check('INFRA_VIABILIDADE')">
        <v-card>
          <v-card-text>
            <div class="text-overline">Em vistoria</div>
            <div class="text-h4 warning--text">{{ contador(vistoria) }}</div>
            <div class="text-caption">aguardando retorno de campo</div>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" sm="6" md="3" v-if="$auth.check('INFRA_POP')">
        <v-card>
          <v-card-text>
            <div class="text-overline">POPs</div>
            <div class="text-h4">{{ contador(pops) }}</div>
            <div class="text-caption">cadastrados</div>
          </v-card-text>
        </v-card>
      </v-col>

      <!-- o menu usa INFRA_DIO, mas a API exige INFRA_DIO_READ no GET /dio -->
      <v-col cols="12" sm="6" md="3" v-if="$auth.check('INFRA_DIO') || $auth.check('INFRA_DIO_READ')">
        <v-card>
          <v-card-text>
            <div class="text-overline">DIOs</div>
            <div class="text-h4">{{ contador(dios) }}</div>
            <div class="text-caption">{{ totalPortas }} portas cadastradas</div>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" sm="6" md="3" v-if="$auth.check('INFRA_CDO')">
        <v-card>
          <v-card-text>
            <div class="text-overline">CDOs</div>
            <div class="text-h4">{{ contador(cdos) }}</div>
            <div class="text-caption">{{ totalCto }} CTOs ativas</div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-card class="mt-4" v-if="$auth.check('INFRA_VIABILIDADE')">
      <v-card-title>
        Viabilidades aguardando
        <v-chip class="ml-2" small color="primary" v-if="aguardando && aguardando.length > 0">
          {{ aguardando.length }}
        </v-chip>
        <v-spacer></v-spacer>
        <v-btn small color="default" @click="todas()">ver todas</v-btn>
      </v-card-title>
      <v-card-subtitle>as mais antigas primeiro</v-card-subtitle>
      <v-card-text>
        <v-alert dense text type="warning" v-if="!loading && aguardando === null">
          Nao foi possivel carregar as viabilidades
        </v-alert>
        <v-alert dense text type="success" v-else-if="aguardando && aguardando.length == 0">
          Nenhuma viabilidade aguardando resposta
        </v-alert>
        <v-simple-table v-else-if="aguardando">
          <thead>
            <tr>
              <th>Operadora</th>
              <th>Cliente</th>
              <th>Cidade</th>
              <th>Entrada</th>
              <th>Espera</th>
              <th>Acoes</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in resumo" :key="item.id">
              <td>{{ item.operadora | formatOperadora }}</td>
              <td>{{ item.cliente }}</td>
              <td>{{ item.cidade }}</td>
              <td>{{ item.inicio | formatDate }}</td>
              <td>
                <v-chip :color="corEspera(item)" text-color="white" small>{{ espera(item) }}</v-chip>
              </td>
              <td>
                <v-btn small color="primary" @click="responder(item)">responder</v-btn>
              </td>
            </tr>
          </tbody>
        </v-simple-table>
        <div class="text-caption mt-2" v-if="aguardando && aguardando.length > limite">
          mostrando as {{ limite }} mais antigas de {{ aguardando.length }}
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import api from "../api/index.js";
import router from "../router/index.js";
export default {
  data: () => ({
    // null = nao carregado ou falha; array = carregado
    aguardando: null,
    vistoria: null,
    pops: null,
    dios: null,
    cdos: null,
    loading: 0,
    limite: 10
  }),
  created: function() {
    this.load();
  },
  computed: {
    // as viabilidades mais antigas primeiro, limitadas ao resumo
    resumo: function() {
      if (!this.aguardando) {
        return [];
      }
      var lista = this.aguardando.slice();
      lista.sort(function(a, b) {
        if (!a.inicio) return 1;
        if (!b.inicio) return -1;
        return a.inicio < b.inicio ? -1 : a.inicio > b.inicio ? 1 : 0;
      });
      return lista.slice(0, this.limite);
    },
    atrasadas: function() {
      var me = this;
      if (!this.aguardando) {
        return [];
      }
      return this.aguardando.filter(function(item) {
        return me.dias(item) >= 3;
      });
    },
    totalPortas: function() {
      if (!this.dios) {
        return 0;
      }
      return this.dios.reduce(function(acc, dio) {
        return acc + (parseInt(dio.portas) || 0);
      }, 0);
    },
    totalCto: function() {
      if (!this.cdos) {
        return 0;
      }
      return this.cdos.reduce(function(acc, cdo) {
        return acc + (parseInt(cdo.ctoDone) || 0);
      }, 0);
    }
  },
  methods: {
    load: function() {
      if (this.$auth.check("INFRA_VIABILIDADE")) {
        this.carrega("/viabilidade/status/1", "aguardando");
        this.carrega("/viabilidade/status/4", "vistoria");
      }
      if (this.$auth.check("INFRA_POP")) {
        this.carrega("/pop", "pops");
      }
      if (this.$auth.check("INFRA_DIO") || this.$auth.check("INFRA_DIO_READ")) {
        this.carrega("/dio", "dios");
      }
      if (this.$auth.check("INFRA_CDO")) {
        this.carrega("/cdo", "cdos");
      }
    },
    // o painel nao interrompe o usuario com alert: o card que falhar mostra "-"
    carrega: function(url, campo) {
      var me = this;
      var token = localStorage.getItem("token");
      me.loading++;
      api
        .get(url, { headers: { Authorization: "Bearer " + token } })
        .then(function(response) {
          me[campo] = response.data || [];
        })
        .catch(function(error) {
          me[campo] = null;
          console.log(error);
        })
        .finally(function() {
          me.loading--;
        });
    },
    contador: function(lista) {
      if (!lista) {
        return "-";
      }
      return lista.length;
    },
    dias: function(item) {
      if (!item.inicio) {
        return 0;
      }
      var inicio = new Date(item.inicio);
      if (isNaN(inicio.getTime())) {
        return 0;
      }
      var ms = new Date().getTime() - inicio.getTime();
      if (ms < 0) {
        return 0;
      }
      return Math.floor(ms / 86400000);
    },
    espera: function(item) {
      var dias = this.dias(item);
      if (dias == 0) {
        return "hoje";
      }
      if (dias == 1) {
        return "1 dia";
      }
      return dias + " dias";
    },
    corEspera: function(item) {
      var dias = this.dias(item);
      if (dias >= 3) {
        return "error";
      }
      if (dias >= 1) {
        return "warning";
      }
      return "success";
    },
    responder: function(item) {
      router.push({ path: `/viabilidade/${item.key}` });
    },
    todas: function() {
      router.push({ path: "/viabilidade" });
    }
  },
  filters: {
    formatOperadora: function(operadora) {
      var text = "";
      if (operadora == 1) {
        text = "Vivavox";
      } else if (operadora == 2) {
        text = "Link1000 - CDM";
      } else if (operadora == 3) {
        text = "Link1000 - CDO";
      } else if (operadora == 4) {
        text = "G2";
      }
      return text;
    }
  }
};
</script>
